import { LuminousGallery } from 'luminous-lightbox'
// multi-image lightbox gallery
const demoTrigger = document.querySelector('.lightbox-trigger')
if (demoTrigger != null) {
  // eslint-disable-next-line no-new
  new LuminousGallery(
    document.querySelectorAll('.lightbox-trigger'),
    {
      arrowNavigation: true
    },
    {
      caption: function (trigger) {
        return trigger.dataset.caption
      }
    }
  )
}
